<template>
  <div class="step-what pb-20 grid grid-cols-2 mdsm:grid-cols-1 gap-20 md:gap-10 sm:gap-6">
    <div>
      <wizard-header
        :curr-step="currStep"
        title="What are you looking for?"
        sub-title="Select up to two things you'd like to see"
      />

      <div class="grid grid-cols-2 sm:grid-cols-1 gap-6 sm:gap-4">
        <wizard-item
          v-for="item in items"
          :key="item.value"
          :title="item.name"
          :icon="item.icon"
          :on-click="() => onChange(item)"
          :disabled="
            selected.length === 2 &&
              !Boolean(selected.find(i => i.value === item.value))
          "
          :active="Boolean(selected.find(i => i.value === item.value))"
          :text-center="false"
        />
      </div>

      <wizard-action
        :on-continue="onContinue"
        :disabledContinue="!selected.length"
      />
    </div>
    <div class="h-full md:hidden sm:hidden">
      <img
        src="/img/wizard/step-what.png"
        alt="wizard-banner"
        class="object-contain h-full w-full"
      />
    </div>
  </div>
</template>

<script>
import WizardHeader from "../../components/Wizard/Header";
import WizardItem from "../../components/Wizard/Item";
import WizardAction from "../../components/Wizard/Action";

export default {
  name: "StepWhat",
  components: {
    WizardHeader,
    WizardItem,
    WizardAction
  },
  mounted() {
    this.init();
  },
  props: {
    currSelection: {
      type: Object,
      default: () => ({})
    },
    currStep: { type: Number, default: 1 },
    items: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    init() {
      const currSelection = this.currSelection;
      const stepWhatData = currSelection["what"];
      this.selected =
        Boolean(stepWhatData) &&
        Array.isArray(stepWhatData) &&
        stepWhatData.length
          ? stepWhatData
          : [];
    },
    onContinue() {
      this.$emit("on-continue", this.selected);
    },
    onChange(specie) {
      let currSelected = [].concat(this.selected);

      if (currSelected.find(i => i.value === specie.value)) {
        currSelected = currSelected.filter(i => i.value !== specie.value);
      } else {
        if (currSelected.length < 2) {
          currSelected = [specie, ...currSelected];
        } else {
          currSelected = [
            specie,
            ...currSelected.slice(0, currSelected.length - 1)
          ];
        }
      }

      this.selected = currSelected;

      this.$emit("on-change", this.selected);
    }
  }
};
</script>
